import { lazy } from 'react';
import { retry } from '../../../config/utils';

const AddressHome = lazy(() =>  retry(()=> import(/* webpackChunkName: "AddressHome" */ "./AddressHome")));

export default AddressHome;